import { Service, FarmerFieldsStates } from "@helpers/ui_helper";
import { farmerStatus, unauthorizedAlert } from "@helpers/unauthorizedAlert";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

function AddNewFieldButton({ setFarmerFieldsState, ref1 }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const reg = searchParams.get("reg");

  useEffect(() => {
    if (reg) {
      searchParams.delete("reg");
      setSearchParams(searchParams);
      setFarmerFieldsState({
        service: Service.SetFieldInfos,
        state:
          farmerStatus() === "DRAFT"
            ? FarmerFieldsStates.AddFieldIntro
            : FarmerFieldsStates.FieldDetails,
        fieldObject: null,
      });
      unauthorizedAlert({ navigate });
    }
  }, [reg]);

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div
        ref={ref1}
        className="flex overflow-visible w-fit items-center cursor-pointer hover:brightness-105 pt-2 gap-4 text-right text-agroyar text-xl max-lg:text-[20px] font-semibold"
        onClick={() => {
          setFarmerFieldsState({
            service: Service.SetFieldInfos,
            state:
              farmerStatus() === "DRAFT"
                ? FarmerFieldsStates.AddFieldIntro
                : FarmerFieldsStates.FieldDetails,
            fieldObject: null,
          });
          unauthorizedAlert({ navigate });
        }}
      >
        افزودن زمین جدید
        <div className="addbtn flex items-center justify-center w-10 h-10 pt-1 rounded-full card-shadow">
          +
        </div>
      </div>
    </div>
  );
}

export default AddNewFieldButton;
